import type {
  DeleteUserResponseDto,
  GetUserResponseDto,
  GetUsersResponseDto,
  InviteUserRequestDto,
  InviteUserResponseDto,
} from 'shared/dtos/users.dto';

import { createAsyncThunk } from '@reduxjs/toolkit';
import UserService from 'services/user.service';

const userService = new UserService();

export const getUsersThunk = createAsyncThunk<GetUsersResponseDto, number>(
  'users/getUsers',
  async (page, thunkAPI) => {
    try {
      const result = await userService.getUsers(page);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const getUserThunk = createAsyncThunk<GetUserResponseDto, number>(
  'users/getUser',
  async (id, thunkAPI) => {
    try {
      const result = await userService.getUser(id);
      return result;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  },
);

export const inviteUserThunk = createAsyncThunk<
  InviteUserResponseDto,
  InviteUserRequestDto & { page: number }
>('users/inviteUser', async (formData, thunkAPI) => {
  try {
    const { page, ...data } = formData;
    const result = await userService.inviteUser(data);
    thunkAPI.dispatch(getUsersThunk(page));
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const deleteUserThunk = createAsyncThunk<
  DeleteUserResponseDto,
  { id: number; page: number }
>('users/deleteUser', async (payload, thunkAPI) => {
  try {
    const { id, page } = payload;
    const result = await userService.deleteUser(id);
    thunkAPI.dispatch(getUsersThunk(page));
    return result;
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});
